import { GetServerSideProps } from "next";
import hospices from "@/constants/hospices_detail.json";
import Head from "next/head";
import NotFoundPage from "pages/404";

import { FUNERAL_SIDO, FUNERAL_SIGUNGU } from "goi_common";
import { HospiceDetailContainer } from "@/containers/HospiceContainer";

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const { id } = params as { id?: string };

  const targetHospice = hospices.find((hospice) => hospice.name === id);

  const sidoKR = FUNERAL_SIDO.get(Number(targetHospice?.sido)) || "";
  const sigunguKR =
    FUNERAL_SIGUNGU.get(Number(targetHospice?.sido))?.get(
      Number(targetHospice?.sigungu)
    ) || "";

  const name = targetHospice?.name || "";
  const description = `${sigunguKR} 호스피스병원, ${name} 시설 정보, 사용료, 후기`;
  const pageOgImage = `${process.env.NEXT_PUBLIC_CDN_URL}/${
    targetHospice?.images[0]?.url || "ogimage.png"
  }`;

  return {
    props: {
      defaulthospice: targetHospice || null,
      hasError: !targetHospice,
      pageDescription: description,
      pageKeywords: `${sigunguKR} 호스피스병원, ${sidoKR} 호스피스병원, ${sidoKR} 호스피스, ${sigunguKR} 호스피스, ${sigunguKR} 호스피스요양병원,  ${name}, ${name} 비용, ${name} 사용료, ${name} 후기`,
      pageOgTitle: `${sidoKR} ${sigunguKR} 호스피스병원, ${name} 정보  - [우리가 찾던 장례전문가, 고이]`,
      pageOgDescription: description,
      pageOgImage: pageOgImage,
    },
  };
};

interface HospicePageProps {
  defaulthospice: any;
  hasError: boolean;
  pageOgTitle: string;
}

function HospiceId({
  defaulthospice,
  hasError,
  pageOgTitle,
}: HospicePageProps) {
  if (hasError) return <NotFoundPage />;

  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>

        <link
          rel="canonical"
          href={`https://www.goifuneral.co.kr/hospice/${defaulthospice.name}/`}
          key="canonical"
        />
      </Head>
      <HospiceDetailContainer hospice={defaulthospice} />
    </>
  );
}

export default HospiceId;
